import React from 'react';
import State from '@wfp-root-app/store/state';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BreadCrumbs from 'src/utils/BreadCrumbs';

import FeatureButton from '../utils/FeatureButton';
import { AuthState } from '../login/auth';
import PartnersList from './PartnersList';
import { ActionCreators } from './partnersActions';
import { ManagerPermission } from '../permission-profiles/permission';
import { BENEFICIARY_SUPPORT_PANEL_URL } from './utils/constants';

interface DispatchProps {
    authorizePartner: (id: string) => void | unknown;
    cancelPartner: (partnerId: string) => void | unknown;
    hideBeneficiarySupportTab: boolean;
}

interface StateProps {
    auth: AuthState;
}

type Props = DispatchProps & StateProps;

class PartnersPage extends React.Component<Props, Record<string, never>> {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.hideBeneficiarySupportTab) {
            return <p>No access</p>;
        }

        return (
            <main>
                <BreadCrumbs path={'/beneficiary-support-panel'} />
                <div className="row">
                    <h3 className="col-sm-5">Beneficiary Support Panel</h3>
                    <div className="col-sm-7 tr">
                        <FeatureButton
                            linkTo={`${BENEFICIARY_SUPPORT_PANEL_URL}/new`}
                            manager={this.props.auth.manager}
                            restrictedToFeatures={[ManagerPermission.partnerPark]}
                            title="Add Organization"
                        />
                    </div>
                </div>
                <PartnersList
                    auth={this.props.auth}
                    authorize={this.props.authorizePartner.bind(this)}
                    handleCancel={this.props.cancelPartner}
                />
            </main>
        );
    }
}

function mapStateToProps(state: State) {
    return {
        auth: state.auth,
        hideBeneficiarySupportTab: state.appConfig.hideBeneficiarySupportTab,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDispatchToProps(dispatch: any) {
    return {
        cancelPartner: bindActionCreators(ActionCreators.cancelPartner, dispatch),
        authorizePartner: bindActionCreators(ActionCreators.authorizePartner, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnersPage);
